module.exports = __webpack_public_path__ + "img/Monte_Kope_81.80cfbdb0.jpg";